module.exports = __webpack_public_path__ + "static/media/history_11.0e4a2889.jpg";